import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import './App.css';
import Login from './Components/Login';
import Navbar from './Components/Navbar';
import ChangeDisplayName from './Components/ChangeDisplayName';
import CreateUser from './Components/CreateUser';
import AddServiceMaster from './Components/AddServiceMaster';
import ChangePassword from './Components/ChangePassword';
import EditRole from './Components/EditRole';
import EditServiceMaster from './Components/EditServiceMaster';
import ResetPassword from './Components/ResetPassword';
import RoleMaster from './Components/RoleMaster';
import RoleServiceMap from './Components/RoleServiceMap';
import ServiceMaster from './Components/ServiceMaster';
import UserRoleService from './Components/UserRoleService';
import AddRole from './Components/AddRole';
import Profile from './Components/Profile';
import Home from './Components/Home';
import FPShopInspectionTwo from './Components/FPSShopInspectionTwo';
import SummaryOfMonthly from './Components/SummaryOfMonthly';
import StockVerificationReport from './Components/StockVerificationReport';
import FPSInspectionReport from './Components/FPSInspectionReport';
import FPSComplainStatusSummary from './Components/FPSComplainStatusSummary';
import BeneficiaryFeedbackReport from './Components/BeneficiaryFeedbackReport';
import Deviation from './Components/Deviation';
import CompletedInspectionsToday from './Components/CompletedInspectionsToday';
import InspectionAllocation from './Components/InspectionAllocation';
import OngoingInspectionToday from './Components/OngoingInspectionToday';
import BatteryDetails from './Components/BatteryDetails';
import GrievanceRegister from './Components/GrievanceRegister';
import MeasuringEquipment from './Components/MeasuringEquipment';
import QuantityOfFoodGrain from './Components/QuantityOfFoodGrain';
import QualityOfFoodGrain from './Components/QualityOfFoodGrain';
import LicensedSite from './Components/LicensedSite';
import MyTargetReport from './Components/MyTargetReport';
import CreateFPS from './Components/CreateFPS';
import InspectionAllocationReport from './Components/InspectionAllocationReport';

import TPDSInspectionReport from './Components/TPDSInspectionReport';
import TPDSComplianceStatusSummary from './Components/TPDSComplianceStatusSummary';
import TPDSStockVerificationReport from './Components/TPDSStockVerificationReport';
import TPDSInspectionSummary from './Components/TPDSInspectionSummary';
import TPDSInspectionAllocationReport from './Components/TPDSInspectionAllocationReport';
import TPDSViewReport from './Components/TPDSViewReport';
import TPDSBeneficiaryFeedbackReport from './Components/TPDSBeneficiaryFeedbackReport';
import InspectionEditFPS from './Components/InspectionEditFPS';

import TeamAllocationEntry from './Components/TeamAllocationEntry';


import CMRCompletedToday from './Components/CMRCompletedToday';
import CmrInspectionReport from './Components/CmrInspectionReport';
import CmrComplainStatusSummary from './Components/CmrComplianceStatusSummary';
import CmrInspectionSummaryReport from './Components/CmrInspectionSummaryReport';
import CmrStockVerification from './Components/CmrStockVerification';
import CMRDashBoard from './Components/CMRDashBoard';

import CMRRoasterEntry from './Components/CMRRoasterEntry';
import TPDSRoasterEntry from './Components/TPDSRoasterEntry';
import CMRViewReport from './Components/CMRViewReport';
import CmrGrainSampleFeedback from './Components/CmrGrainSampleFeedback';
import CmrMyTargetReport from './Components/CmrMyTargetReport';
import TPDSMyTargetReport from './Components/TPDSMyTargetReport';
import CMRInspectionAllocationReport from './Components/CMRInspectionAllocationReport';
import TPDSDashBoard from './Components/TPDSDashBoard';
import TPDSDeviation from './Components/TPDSDeviation';

import CmrDeviation from './Components/CmrDeviation';
import CmrGrievanceRegister from './Components/CmrGrievanceRegister';
import CmrMeasuringEquipment from './Components/CmrMeasuringEquipment';
import CmrQuantityOfFoodGrain from './Components/CmrQuantityOfFoodGrain';
import CmrQualityOfFoodGrain from './Components/CmrQualityOfFoodGrain';
import CmrLicensedSite from './Components/CmrLicensedSite';
import TPDSGrievanceRegister from './Components/TPDSGrievanceRegister';
import TPDSMeasuringEquipment from './Components/TPDSMeasuringEquipment';
import TPDSQuantityOfFoodGrain from './Components/TPDSQuantityOfFoodGrain';
import TPDSQualityOfFoodGrain from './Components/TPDSQualityOfFoodGrain';
import TPDSLicensedSite from './Components/TPDSLicensedSite';
import CmrOngoingInspectionToday from './Components/CmrOngoingInspectionToday';
import TPDSOngoingInspectionToday from './Components/TPDSOngoingInspectionToday';
import TPDSCompletedToday from './Components/TPDSCompletedToday';
import InspectionAllocationTeam from './Components/InspectionAllocationTeam';
import CMRRoasterEntryTeam from './Components/CMRRoasterEntryTeam';
import TPDSRoasterEntryTeam from './Components/TPDSRoasterEntryTeam';
import FPSInspectionRation from './Components/FPSInspectionRation';
import RationReport from './Components/RationReport';
import Beneficiaries from './Components/Beneficiaries';
import FPSlatlong from './Components/FPSlatlong';
import InspectionOfficerPhoto from './Components/InspectionOfficerPhoto';
import FPSRationEntry from './Components/FPSRationEntry';
import FPSNewRationAdded from './Components/FPSNewRationAdded';
import WebSitePolicy from './Components/WebSitePolicy';
import FPSMasterDataNotPresent from './Components/FPSMasterDataNotPresent';
import FPSMasterOrNot from './Components/FPSMasterOrNot';
import OfficerInspectionCounts from './Components/OfficerInspectionCounts';
import AllDistrictsAndSubdivisions from './Components/AllDistrictsAndSubdivisions';
import Discrepancy from './Components/Discrepancy';
import ExistingStockVerificationReport from './Components/ExistingStockVerificationReport';
import ActionTakenReport from './Components/ActionTakenReport';
import DiscrepancySubDivisionWise from './Components/DiscrepancySubDivisionWise';
import ExistingStockVerificationUpdation from './Components/ExistingStockVerificationUpdation';
import ActionTakenUpdate from './Components/ActionTakenUpdate';
import ATRDetailedReport from './Components/ATRDetailedReport';
import CMRATREntryForm from './Components/CMRATREntryForm';
import CMRATRUpdateForm from './Components/CMRATRUpdateForm';
import TPDSATREntryForm from './Components/TPDSATREntryForm';
import TPDSATRUpdateForm from './Components/TPDSATRUpdateForm';
import CMRDiscrepancyReport from './Components/CMRDiscrepancyReport';
import TPDSDiscrepancyReport from './Components/TPDSDiscrepancyReport';
import CMRDetailedReport from './Components/CMRDetailedReport';
import TPDSDetailedReport from './Components/TPDSDetailedReport';
import QcCMRInspection from './Components/QcCMRInspection';
import QcCMRViewReport from './Components/QcCMRViewReport';
import QcTPDSInspection from './Components/QcTPDSInspection';
import QcTPDSViewReport from './Components/QcTPDSViewReport';

// QC-CMR Rice
import QcCMRATREntry from './Components/QcCMRATREntry';
import QcCMRATRUpdate from './Components/QcCMRATRUpdate';
import QcCMRiceDiscrepancy from './Components/QcCMRiceDiscrepancy';

//QC-CMR Wheat
import QcCMRWhATREntryForm from './Components/QcCMRWhATREntryForm';
import QcCMRWhATRUpdateForm from './Components/QcCMRWhATRUpdateForm';
import QcCMRWheatDiscrepancy from './Components/QcCMRWheatDiscrepancy';

//QC-TPDS Rice
import QcTPDSEntry from './Components/QcTPDSEntry';
import QcTPDSUpdate from './Components/QcTPDSUpdate';
import QcTPDSRiceDiscrepancy from './Components/QcTPDSRiceDiscrepancy';


//QC-TPDS Wheat
import QcTPDSWhATREntry from './Components/QcTPDSWhATREntry';
import QcTPDSWhATRUpdate from './Components/QcTPDSWhATRUpdate';
import QcTPDSWheatDiscrepancy from './Components/QcTPDSWheatDiscrepancy';
import QcCmrDashboard from './Components/QcCmrDashboard';
import QcTpdsDashboard from './Components/QcTpdsDashboard';
import QcCmrCompletedInspections from './Components/QcCmrCompletedInspectionsToday';
import QCCmrOngoingInspectionToday from './Components/QcCmrOngoingInspectionToday';
import QcTpdsCompletedInspections from './Components/QcTpdsCompletedInspectionsToday';
import QcCmrCompletedInspectionsToday from './Components/QcCmrCompletedInspectionsToday';
import QcTpdsCompletedInspectionsToday from './Components/QcTpdsCompletedInspectionsToday';
import QcTpdsOnongingInspectionsToday from './Components/QcTpdsOnongingInspectionsToday';
//import SubDivisionWiseInspectionSummaryForAllDistricts from './Components/SubDivisionWiseInspectionSummaryForAllDistricts';
import ATRZODReportWithFilters from './Components/ATRZODReportWithFilters';



const App = () => {
  const isAuthenticated = localStorage.getItem("user") !== null;


  return (
    <Router>
      <div className="App">
        <Navbar />
        <div className="content">
          <Routes>
            {/* Public routes */}
            <Route
              path="/login"
              element={isAuthenticated ? <Navigate to="/home" replace /> : <Login />}
            />
            <Route path="/webSitePolicy" element={<WebSitePolicy />} />
            {/* Protected routes */}
            {isAuthenticated ? (
              <>

                {/* This below User based url's */}
                <Route path="/changeDisplayName" element={<ChangeDisplayName />} />
                <Route path="/createUser" element={<CreateUser />} />
                <Route path="/profile" element={<Profile />} />


                {/* This below Admin based url's */}
                <Route path="/addRole" element={<AddRole />} />
                <Route path="/addServiceMaster" element={<AddServiceMaster />} />
                <Route path="/changePassword" element={<ChangePassword />} />
                <Route path="/editRole" element={<EditRole />} />
                <Route path="/editServiceMaster" element={<EditServiceMaster />} />
                <Route path="/resetPassword" element={<ResetPassword />} />
                <Route path="/roleMaster" element={<RoleMaster />} />
                <Route path="/roleServiceMap" element={<RoleServiceMap />} />
                <Route path="/serviceMaster" element={<ServiceMaster />} />
                <Route path="/userRoleService" element={<UserRoleService />} />
                <Route path="/createFPS" element={<CreateFPS />} />

                {/* This below Home Reports based url's */}
                <Route path="/home" element={<Home />} />
                <Route path="/cmrDashboard" element={<CMRDashBoard />} />

                <Route path="/deviation" element={<Deviation />} />
                <Route path="/completedInspectionsToday" element={<CompletedInspectionsToday />} />
                <Route path="/ongoingInspectionToday" element={< OngoingInspectionToday />} />
                <Route path="/inspectionAllocation" element={<InspectionAllocation />} />
                <Route path="/battery-details/:range" element={<BatteryDetails />} />
                <Route path="/grievanceRegister" element={<GrievanceRegister />} />
                <Route path="/measuringEquipment" element={<MeasuringEquipment />} />
                <Route path="/quantityOfFoodGrain" element={<QuantityOfFoodGrain />} />
                <Route path="/qualityOfFoodGrain" element={<QualityOfFoodGrain />} />
                <Route path="/licensedSite" element={<LicensedSite />} />

                {/* This below FPS Reports based url's */}
                <Route path="/summaryOfMonthly" element={<SummaryOfMonthly />} />
                <Route path="/stockVerificationReport" element={<StockVerificationReport />} />
                <Route path="/beneficiaryFeedbackReport" element={<BeneficiaryFeedbackReport />} />
                <Route path="/fpsComplainStatusSummary" element={<FPSComplainStatusSummary />} />
                <Route path="/fpsShopInspectionTwo" element={<FPShopInspectionTwo />} />
                <Route path="/fpsInspectionReport" element={<FPSInspectionReport />} />
                <Route path="/myTargertReport" element={<MyTargetReport />} />
                <Route path="/inspectionAllocationReport" element={<InspectionAllocationReport />} />
                <Route path="/inspectionTeam" element={<InspectionAllocationTeam />} />
                <Route path="/fpsMasterDataNotPresent" element={<FPSMasterDataNotPresent />} />
                <Route path="/fpsMasterOrNot" element={<FPSMasterOrNot />} />
                {/* This below TPDS Reports based url's */}
                {/* <Route path="/godownRoasterEntry" element={<GodownRoasterEntry/>}/> */}
                <Route path="/tpdsInspectionReport" element={<TPDSInspectionReport />} />
                <Route path="/tpdsComplaintStatusSummary" element={<TPDSComplianceStatusSummary />} />
                <Route path="/tpdsStockVerificationReport" element={<TPDSStockVerificationReport />} />
                <Route path="/tpdsBeneficiaryFeedbackReport" element={<TPDSBeneficiaryFeedbackReport />} />
                <Route path="/tpdsInspectionSummary" element={<TPDSInspectionSummary />} />
                <Route path="/tpdsInspectionAllocationReport" element={<TPDSInspectionAllocationReport />} />
                <Route path="/tpdsViewReport" element={<TPDSViewReport />} />
                <Route path="/tpdsMyTargetReport" element={<TPDSMyTargetReport />} />
                <Route path="/tpdsDashboard" element={<TPDSDashBoard />} />
                <Route path='/tpdsDeviation' element={<TPDSDeviation />} />


                {/*  cmr based url*/}
                <Route path="/cmrRoasterEntry" element={<CMRRoasterEntry />} />
                <Route path='/cmrInspectionReport' element={<CmrInspectionReport />} />
                <Route path='/cmrComplianceStatusSummary' element={<CmrComplainStatusSummary />} />
                <Route path='/cmrInspectionSummaryReport' element={<CmrInspectionSummaryReport />} />
                <Route path='/cmrStockReport' element={<CmrStockVerification />} />
                <Route path="/cmrViewReport" element={<CMRViewReport />} />
                <Route path="/cmrGrainSampleFeedback" element={<CmrGrainSampleFeedback />} />
                <Route path="/cmrMyTargetReport" element={<CmrMyTargetReport />} />
                <Route path="/cmrInspectionAllocationReport" element={<CMRInspectionAllocationReport />} />
                <Route path="/cmrRoasterTeam" element={<CMRRoasterEntryTeam />} />


                {/*tpds roaster entry url */}
                <Route path='/tpdsRoasterEntry' element={<TPDSRoasterEntry />} />


                <Route path='/cmrDeviation' element={<CmrDeviation />} />
                <Route path='/cmrGrievanceRegister' element={<CmrGrievanceRegister />} />
                <Route path='/cmrMeasuringEquipment' element={<CmrMeasuringEquipment />} />
                <Route path='/cmrelectricity' element={<CmrQuantityOfFoodGrain />} />
                <Route path='/cmrweighmachine' element={<CmrQualityOfFoodGrain />} />
                <Route path='/cmrLicensedSite' element={<CmrLicensedSite />} />
                <Route path="/cmrCompletedToday" element={<CMRCompletedToday />} />

                <Route path='/cmrOngoingInspectionToday' element={<CmrOngoingInspectionToday />} />

                <Route path='/tpdsGrievanceRegister' element={<TPDSGrievanceRegister />} />
                <Route path='/tpdsMeasuringEquipment' element={<TPDSMeasuringEquipment />} />
                <Route path='/tpdsElectricityConnection' element={<TPDSQuantityOfFoodGrain />} />
                <Route path='/tpdsWeighMachineAvailable' element={<TPDSQualityOfFoodGrain />} />
                <Route path='/tpdsLicensedSite' element={<TPDSLicensedSite />} />
                <Route path='/tpdsOngoingInspectionToday' element={<TPDSOngoingInspectionToday />} />
                <Route path='/tpdsCompletedToday' element={<TPDSCompletedToday />} />
                <Route path="/tpdsRoasterTeam" element={<TPDSRoasterEntryTeam />} />
                <Route path="/fpsinspectionration" element={<FPSInspectionRation />} />
                <Route path="/rationReport" element={<RationReport />} />

                <Route path="/beneficiaries" element={<Beneficiaries />} />
                <Route path="/fpsLatlong" element={<FPSlatlong />} />
                <Route path="/inspectionOfficerPhoto" element={<InspectionOfficerPhoto />} />
                <Route path="/fpsRationEntry" element={<FPSRationEntry />} />
                <Route path="/fpsNewRationAdded" element={<FPSNewRationAdded />} />

                <Route path="/officerInspectionCounts" element={<OfficerInspectionCounts />} />
                <Route path="/subDivisionsAndAllDistricts" element={<AllDistrictsAndSubdivisions />} />
                <Route path="/discrepancyReport" element={<Discrepancy />} />
                <Route path="/existingStockVerificationReport" element={<ExistingStockVerificationReport />} />
                <Route path="/actionTakenReport" element={<ActionTakenReport />} />
                <Route path="/discrepancySubDivisionWise" element={<DiscrepancySubDivisionWise />} />
                <Route path="/existingStockVerificationUpdation" element={<ExistingStockVerificationUpdation />} />
                <Route path="/actionTakenUpdate" element={<ActionTakenUpdate />} />
                <Route path="/atrDetailedReport" element={<ATRDetailedReport />} />
                <Route path="/cmrAtrEntryForm" element={<CMRATREntryForm />} />
                <Route path="/cmrAtrUpdationForm" element={<CMRATRUpdateForm />} />
                <Route path="/tpdsATREntryForm" element={<TPDSATREntryForm />} />
                <Route path="/tpdsATRUpdateForm" element={<TPDSATRUpdateForm />} />
                <Route path="/cmrDiscrepancyReport" element={<CMRDiscrepancyReport />} />
                <Route path="/tpdsDiscrepancyReport" element={<TPDSDiscrepancyReport />} />
                <Route path="/cmrDetailedReport" element={<CMRDetailedReport />} />
                <Route path="/tpdsDetailedReport" element={<TPDSDetailedReport />} />

                {/*  qccmr based url*/}
                <Route path="/qcCMRInspection" element={<QcCMRInspection />} />
                <Route path="/qcCMRViewReport" element={<QcCMRViewReport />} />
                {/* QC-CMR Rice */}
                <Route path="/qcCMRATREntry" element={<QcCMRATREntry />} />
                <Route path="/qcCMRATRUpdate" element={<QcCMRATRUpdate />} />
                <Route path="/qcCMRiceDiscrepancy" element={<QcCMRiceDiscrepancy />} />
                {/* QC-CMR Wheat */}
                <Route path="/qcCMRWhATREntryForm" element={<QcCMRWhATREntryForm />} />
                <Route path="/qcCMRWhATRUpdateForm" element={<QcCMRWhATRUpdateForm />} />
                <Route path="/qcCMRWheatDiscrepancy" element={<QcCMRWheatDiscrepancy />} />


                {/*  QCTPDS based url*/}
                <Route path="/qcTPDSInspection" element={<QcTPDSInspection />} />
                <Route path="/qcTPDSViewReport" element={<QcTPDSViewReport />} />
                {/* QC-TPDS Rice  */}
                <Route path="/qcTpdsATREntryForm" element={<QcTPDSEntry />} />
                <Route path="/qcTpdsATRUpdateForm" element={<QcTPDSUpdate />} />
                <Route path="/qcTPDSRiceDiscrepancy" element={<QcTPDSRiceDiscrepancy />} />
                {/* QC-TPDS Wheat  */}
                <Route path="/qcTPDSWhATREntry" element={<QcTPDSWhATREntry />} />
                <Route path="/qcTPDSWhATRUpdate" element={<QcTPDSWhATRUpdate />} />
                <Route path="/qcTPDSWheatDiscrepancy" element={<QcTPDSWheatDiscrepancy />} />

                <Route path="/qcCmrDashboard" element={<QcCmrDashboard />} />
                <Route path="/qcTpdsDashboard" element={<QcTpdsDashboard />} />
                <Route path="/qcCmrCompletedInspectionToday" element={<QcCmrCompletedInspectionsToday />} />
                <Route path="/QcCmrOngoingInspectionToday" element={<QCCmrOngoingInspectionToday />} />
                <Route path="/qcTpdsCompletedInspectionsToday" element={<QcTpdsCompletedInspectionsToday />} />
                <Route path="/QcTpdsOnongingInspectionsToday" element={<QcTpdsOnongingInspectionsToday />} />
                  {/* <Route path="/subdiwisionWiseInspection" element={<SubDivisionWiseInspectionSummaryForAllDistricts/>}/>  */}
                <Route path="aTRZODReportWithFilters" element={<ATRZODReportWithFilters/>}/>


                <Route path="*" element={<Navigate to="/home" replace />} />

              </>
            ) : (
              // Catch-all route for undefined URLs when not logged in
              <Route path="*" element={<Navigate to="/" replace />} />
            )}
          </Routes>
        </div>
      </div>
    </Router>

  );
};

export default App;

